/**
 * Header component
 *
 * Top navigation bar for your site. Set to remain visible as the
 * user scrolls so that they can constantly reach any part of your page.
 */
import React from "react";

const Header = () => {
  return (
    <div
      style={{
        position: "fixed",
        display: "flex",
        justifyContent: "center",
        gap: "2rem",
        background: "rgba(255,255,255,0.75)",
        padding: "1rem",
        top: 0,
        width: "100%",
        zIndex: 10,
      }}
    >
      <a href="#home">Inicio</a>
      <a href="#about">Sobre Mí</a>
      <a href="#portfolio">Proyectos</a>
      <a href="#blog">Blog</a>
      <a href="#footer">Contacto</a>
    </div>
  );
};

export default Header;
